<template>
  <div class="g-container" :class="{'mobile': _isMobile, 'pc': !_isMobile, 'weixin': $store.state.app.platform=='minipro'}">
    <cmp-header ref="cmpHeader" v-if="!_isMobile"></cmp-header>

    <cmp-header-h5 v-if="_isMobile&&$store.state.app.platform!='minipro'"></cmp-header-h5>

    <!-- <cmpBread v-if="!$route.meta.hideBread"></cmpBread> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <cmpFooter v-if="$store.state.app.platform!='minipro'"></cmpFooter>
  </div>
</template>

<script>
import cmpHeader from '@cmp/header/index'
import cmpHeaderH5 from '@cmp/header/header-h5'
import cmpFooter from '@cmp/footer'
export default {
  components: {
    cmpHeader,
    cmpHeaderH5,
    cmpFooter
  },
  methods: {
    getData() {
      this.$http
        .get('/webapi/index', {})
        .then(res => {
          if (res.success) {
            this.$store.dispatch('setGlobalInfo', {
              friendLink: res.data.friendLink,
              museumInfo: res.data.museumInfo
            })
          } else {
            this.$message.error(res.message)
          }
        })
    }
  },
  created() {
    this.getData()
  }
  // methods: {
  //   handleScroll() {
  //     console.log(11)
  //   }
  // },
  // mounted() {
  //   console.log(222)
  //   window.addEventListener('scroll', this.handleScroll)
  // },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll)
  // }
}
</script>